import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SettingsCtx = createContext({ settings: {}, refresh: () => {} });
export const useSettings = () => useContext(SettingsCtx);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/site-settings");
      setSettings(r.data);
    } catch { /* noop */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <SettingsCtx.Provider value={{ settings, refresh }}>{children}</SettingsCtx.Provider>;
}
